<script>
    import { onMount, tick } from "svelte";
    import { user } from "../../routes/user/user.state.svelte.js";
    import vulnerabilitiesApi from "../../routes/vulnerability/vulnerabilities.api.js";
    import TOML from "toml-js";
    import { format, locale } from "svelte-i18n";

    let { value } = $props();
    let data = $derived(value);

    let tooltip = $state();
    let link = $derived(user.data.is_internal ? getEditLink(value) : "");

    const getEditLink = (row) => {
        if (!row) return;
        let types = {
            asvs4: "asvs4",
            aws: "aws",
            azure: "azure",
            burp: "burp",
            cis: "cis",
            cve: "cve",
            leak: "leak",
            nuclei: "nuclei",
            nvt: "nvt",
            ad: "pingcastle",
            sve: "sve",
            x: "vulnerability",
            T1557: "attck",
        };

        if (row && !row.id) return "#";
        let vul_kb_url = vulnerabilitiesApi.kb_url;
        let type = row.id.split("-" || ".")[0].toLowerCase();
        return type === "x"
            ? `/vulnerability/${row.id}`
            : `${vul_kb_url}/${types[type]}/${row.id}.toml`;
    };

    const handleTOMLCopy = async (vul_id) => {
        if (!vul_id) return;
        let row = await vulnerabilitiesApi.findVulnerability(vul_id);
        let { id, title, title_es, summary, summary_es } = row;
        let tomlFields = {
            id: id,
            title: title,
            title_es: title_es,
            summary: summary,
            summary_es: summary_es,
        };
        let toml = TOML.dump(tomlFields);
        copyText(toml, tooltip);
    };

    const copyText = async (str, tooltip) => {
        let selBox = document.createElement("textarea");
        selBox.style.position = "fixed";
        selBox.style.left = "0";
        selBox.style.top = "0";
        selBox.style.opacity = "0";
        selBox.value = str;
        document.body.appendChild(selBox);
        selBox.focus();
        selBox.select();
        // @TODO: upgrade to clipboard API
        document.execCommand("copy");
        showTooltip(tooltip);
        document.body.removeChild(selBox);
        hideTooltip(tooltip);
    };

    const hideTooltip = (tooltip) => {
        setTimeout(() => {
            tooltip.classList.add("trigger-opacity-cero");
            tooltip.classList.remove("trigger-opacity-one");
            setTimeout(() => tooltip.classList.add("d-none"), 1000);
        }, 2000);
    };

    const showTooltip = (tooltip) => {
        tooltip.classList.remove("d-none");
        setTimeout(() => {
            tooltip.classList.remove("trigger-opacity-cero");
            tooltip.classList.add("trigger-opacity-one");
        }, 1000);
    };
    onMount(async () => {
        await tick();
        if (user.data.is_internal) {
            link = getEditLink(data);
        }
    });
</script>

{#if data}
    <a href={`/vulnerability/${data["id"]}`}
        >{data.title_es ? data.title_es : data.title}
        {data.id.includes("CVE") ? `(${data.id})` : ""}</a
    >
    {#if user.data.is_internal && data.id.includes("X-")}
        <a
            href={link}
            class="btn btn-gitlab"
            target="_blank"
            title={$format("buttons.edit")}
            data-id={data["id"]}><i class="fas fa-edit"></i></a
        >
    {/if}
{/if}

<style>
</style>
